/**
 * FullStacked Cloud - Auth UI entrypoint (a.fullstacked.cloud / auth.fullstacked.cloud).
 */

import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import ClerkAuthView from "./src/clerk-auth.tsx";
import { PasskeyRegisterView } from "./src/passkey-register.tsx";
import "./index.css";

const MODE_BADGE: Record<string, string> = {
    popup: "APPLICATION SIGN-IN",
    native: "FULLSTACKED APP SIGN-IN",
    callback: "CONSOLE SIGN-IN",
    billing: "PLAN & BILLING",
};

export function AuthApp() {
    const [mode, setMode] = useState("standalone");
    const sandbox = window.location.hostname !== "auth.fullstacked.cloud";
    return (
        <div style={{ maxWidth: "440px", margin: "48px auto", padding: "0 16px" }}>
            <header
                style={{
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "8px",
                }}
            >
                <div>
                    <h2
                        style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "var(--fs-text-primary)",
                        }}
                    >
                        FullStacked Cloud
                    </h2>
                    <span style={{ fontSize: "12px", color: "var(--fs-text-tertiary)" }}>
                        Identity & Single Sign-On
                    </span>
                </div>
                <div style={{ display: "flex", gap: "6px" }}>
                    {MODE_BADGE[mode] && (
                        <span className="badge badge-brand">{MODE_BADGE[mode]}</span>
                    )}
                    {sandbox && <span className="badge badge-env-test">TEST</span>}
                </div>
            </header>
            {window.location.pathname === "/passkeys/register" ? (
                <PasskeyRegisterView />
            ) : (
                <ClerkAuthView onModeChange={setMode} />
            )}
        </div>
    );
}

const rootEl = document.getElementById("root");
if (rootEl) createRoot(rootEl).render(<AuthApp />);
